module.exports = "pegasus_template/assets/themecapture1/small/12.png";